// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/svg/Previous.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/svg/next.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.env_container {
  background: linear-gradient(140.22deg, rgb(151, 71, 255) -5.17%, rgb(238, 58, 36) 112.64%);
  display: flex;
  min-height: 100vh;
  flex-wrap: wrap;
}
.env_container > div {
  width: 48%;
  margin: 1%;
}

button.slick-arrow.slick-prev.slick-disabled, button.slick-arrow.slick-next.slick-disabled {
  display: none !important;
}

.env-slider-container {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 3px;
  margin-left: -1.68234375vw;
  border: 2px solid;
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  padding: 1.65vw 3.65953125vw 2.22vw 3.65953125vw;
}

.side-nav .env-slider-container {
  width: 71.085vw;
}

.side-nav.close .env-slider-container {
  width: 88.245vw;
}

.slick-slide {
  width: 329px;
}

.env-slider-container .slick-slider .slick-track, .slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.stepper-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-items: center;
  margin: 1.3vw 0;
}

.setupguide-btn {
  position: relative;
  right: 9.62725vw;
}

.setupguide-btn button {
  font-size: 0.901875vw;
  font-weight: 500;
  color: #EE3A24;
  line-height: 1.24875vw;
  border: 1px solid #EE3A24;
  padding: 0.85vw 3.33vw;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
  background-color: transparent;
}

.carrusel__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item {
  position: relative;
}

.item .play-icon svg {
  position: absolute;
  top: 50%;
  left: 54%;
  transform: translate(-50%, -50%);
}

.item img:hover + .play-icon svg, .item .play-icon:hover svg {
  filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg) brightness(87%) contrast(116%);
}

.item .title {
  position: absolute;
  font-size: 0.8325vw;
  font-weight: 400;
  line-height: 0.901875vw;
  bottom: 5%;
  right: 5%;
  padding: 8px 24px;
  background: rgba(226, 226, 226, 0.7490196078);
  color: #0E0E0E;
  border-radius: 3px, 0px, 0px, 3px;
}

.item img {
  height: 12.834375vw;
  width: 22.824375vw;
  margin: auto;
}

.slick-slide img {
  height: calc(100% - 12px) !important;
  width: calc(100% - 24px) !important;
  border-radius: 3px 0;
}

.slick-prev {
  left: -1.3875vw;
}

.slick-next {
  right: -1.3875vw;
}

.slick-prev::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  padding: 6px;
}

.slick-next::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  padding: 6px;
}

.image-box,
.image-box img {
  height: 100%;
}

.wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, #834d9b, #d04ed6);
}

.wrapper a {
  display: inline-block;
  text-decoration: none;
  padding: 15px;
  background-color: #fff;
  border-radius: 3px;
  text-transform: uppercase;
  color: #585858;
  font-family: "Roboto", sans-serif;
}

.modal {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(77, 77, 77, 0.7);
  transition: all 0.4s;
}

.modal:target {
  visibility: visible;
  opacity: 1;
}

.modal__content {
  border-radius: 4px;
  position: relative;
  width: 500px;
  max-width: 90%;
  background: #fff;
  padding: 1em 2em;
}

.modal__footer {
  text-align: right;
}
.modal__footer a {
  color: #585858;
}
.modal__footer i {
  color: #d02d2c;
}

.modal__close {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #585858;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/style/components/store/SelectEnv.scss"],"names":[],"mappings":"AAAA;EACI,0FAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;AACJ;AACI;EACI,UAAA;EACA,UAAA;AACR;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,yGAAA;EACA,kBAAA;EAEJ,0BAAA;EACI,iBAAA;EACJ,6GAAA;EAEA,+DAAA;EAEA,gDAAA;AAFA;;AAMA;EACI,eAAA;AAHJ;;AAKA;EACI,eAAA;AAFJ;;AAIA;EACI,YAAA;AADJ;;AAGA;EACI,+BAAA;AAAJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADJ;;AAKA;EACI,gGAAA;AAFJ;;AAIA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,6CAAA;EACA,cAAA;EACJ,iCAAA;AADA;;AAIA;EACI,mBAAA;EACA,kBAAA;EACA,YAAA;AADJ;;AAIA;EACI,oCAAA;EACA,mCAAA;EACA,oBAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;AADJ;;AAIA;EACI,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;AADJ;;AAIA;;EAEI,YAAA;AADJ;;AAIA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,uDAAA;AADJ;;AAIE;EACE,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,iCAAA;AADJ;;AAIE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,oBAAA;AADJ;;AAIE;EACE,mBAAA;EACA,UAAA;AADJ;;AAIE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AADJ;;AAIE;EACE,iBAAA;AADJ;AAEI;EACE,cAAA;AAAN;AAEI;EACE,cAAA;AAAN;;AAGE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;AAAJ","sourcesContent":[".env_container {\n    background: linear-gradient(140.22deg, rgb(151, 71, 255) -5.17%, rgb(238, 58, 36) 112.64%);\n    display: flex;\n    min-height: 100vh;\n    flex-wrap: wrap;\n\n    &>div {\n        width: 48%;\n        margin: 1%;\n    }\n}\nbutton.slick-arrow.slick-prev.slick-disabled,button.slick-arrow.slick-next.slick-disabled {\n    display: none!important;\n}\n\n.env-slider-container {\n    background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n    border-radius: 3px;\n    // margin: 1.09265625vw ;\nmargin-left: -1.68234375vw;\n    border: 2px solid;\nborder-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);\n// box-shadow: -5px -5px 250px 0px #FFFFFF05 inset;\nbox-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n// margin: 0 3.65953125vw;  \npadding: 1.65vw 3.65953125vw 2.22vw 3.65953125vw;\n    // padding: 1.5rem 1rem;\n   \n}\n.side-nav .env-slider-container{\n    width: 71.085vw;\n}\n.side-nav.close .env-slider-container{\n    width: 88.245vw;\n}\n.slick-slide{\n    width: 329px;\n}\n.env-slider-container .slick-slider .slick-track, .slick-slider .slick-list{\n    transform: translate3d(0, 0, 0) ;\n}\n.stepper-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    align-items: center;\n    margin: 1.30vw 0;\n}\n\n.setupguide-btn {\n    position: relative;\n    right: 9.62725vw;\n}\n\n.setupguide-btn button {\n    font-size: 0.901875vw;\n    font-weight: 500;\n    color: #EE3A24;\n    line-height: 1.24875vw;\n    border: 1px solid #EE3A24;\n    padding: .85vw 3.33vw;\n    cursor: pointer;\n    border-radius: 3px;\n    text-align: center;\n    background-color: transparent;\n}\n\n.carrusel__wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.item {\n    position: relative;\n}\n\n.item .play-icon svg{\n   \n    position: absolute;\n    top: 50%;\n    left: 54%;\n    transform: translate(-50%, -50%);\n   \n}\n\n.item img:hover + .play-icon svg,.item .play-icon:hover svg {\n    filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg) brightness(87%) contrast(116%);\n}\n.item .title {\n    position: absolute;\n    font-size: 0.8325vw;\n    font-weight: 400;\n    line-height: 0.901875vw;\n    bottom: 5%;\n    right: 5%;\n    padding: 8px 24px;\n    background: #E2E2E2BF;\n    color: #0E0E0E;\nborder-radius: 3px, 0px, 0px, 3px;\n    // transform: translate(-50%, -50%);\n}\n.item img {\n    height: 12.834375vw;\n    width: 22.824375vw;\n    margin: auto;\n   }\n\n.slick-slide img {\n    height: calc(100% - 12px) !important;\n    width: calc(100% - 24px) !important;\n    border-radius: 3px 0;\n}\n\n.slick-prev {\n    left: -1.3875vw;\n}\n\n.slick-next {\n    right: -1.3875vw;\n}\n\n.slick-prev::before {\n    content: '';\n    background-image: url('../../../assets/svg/Previous.svg');\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding: 6px;\n}\n\n.slick-next::before {\n    content: '';\n    background-image: url('../../../assets/svg/next.svg');\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding: 6px;\n}\n\n.image-box,\n.image-box img {\n    height: 100%;\n}\n\n.wrapper {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: -webkit-linear-gradient(to right, #834d9b, #d04ed6);\n    background: linear-gradient(to right, #834d9b, #d04ed6);\n  }\n  \n  .wrapper a {\n    display: inline-block;\n    text-decoration: none;\n    padding: 15px;\n    background-color: #fff;\n    border-radius: 3px;\n    text-transform: uppercase;\n    color: #585858;\n    font-family: 'Roboto', sans-serif;\n  }\n  \n  .modal {\n    visibility: hidden;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(77, 77, 77, .7);\n    transition: all .4s;\n  }\n  \n  .modal:target {\n    visibility: visible;\n    opacity: 1;\n  }\n  \n  .modal__content {\n    border-radius: 4px;\n    position: relative;\n    width: 500px;\n    max-width: 90%;\n    background: #fff;\n    padding: 1em 2em;\n  }\n  \n  .modal__footer {\n    text-align: right;\n    a {\n      color: #585858;\n    }\n    i {\n      color: #d02d2c;\n    }\n  }\n  .modal__close {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    color: #585858;\n    text-decoration: none;\n  }\n// @media only screen and (max-width: 500px){\n//     .setupguide-btn {\n//         position: relative;\n//         right: 0;\n//         margin: 1rem 0;\n//     }\n//     .slick-slide img {\n//         width: calc(100% - 0px) !important;\n//     }\n//     .slider-container {\n//         margin: 1rem 0;\n//     }\n// }\n\n\n// @media only screen and (min-width: 501px) and (max-width: 600px) {\n//     .setupguide-btn {\n//         position: relative;\n//         right: 0;\n//         margin: 1rem 0;\n//     }\n//     .slider-container {\n//         margin: 1rem 0;\n//     }\n// }\n// @media only screen and (min-width: 601px)  {\n    \n//     .slider-container {\n//         margin: 1rem 2rem;\n//     }\n// }\n\n// @media only screen and (min-width: 601px) and (max-width: 675px) {\n//     .setupguide-btn {\n//         position: relative;\n//         right: 0;\n//         margin: 1rem 0;\n//     }\n    \n// }\n// @media only screen and (min-width: 601px) and (max-width: 768px) {\n// .setupguide-btn{\n//     position: relative;\n//     right: 0;\n//     margin: 1rem 0;\n// }\n// }\n// @media only screen and (max-width: 768px) {\n//     .stepper-container {\n//         display: block;\n//     }\n//     .slider-container {\n//         background-image: radial-gradient(#FFFFFF66 40%, #EEEDED 20%);\n//         border-radius: 3px;\n//         padding: 1.5rem ;\n//     }\n// }\n// @media only screen and (min-width: 501px) and (max-width: 768px) {\n//     .slick-slide img {\n//         width: calc(100% - 32px) !important;\n//     }\n// }\n\n// @media only screen and (min-width: 769px) and (max-width: 900px) {\n\n//     .setupguide-btn {\n//         right: 2rem;\n//     }\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
